<div class="wrapper">
  <ng-content></ng-content>

  <div *ngIf="!!description" class="wrapper__description">{{ description }}</div>
</div>
